import React from "react";
import Link from "gatsby-link";
import ClassNames from "classnames";
import RenderHtml from "../utils/render-html";

let FAQS = [];

class FAQs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      n: 0
    };
  }

  render() {
    let FAQS = this.props.data;
    return (
      <div className="FAQs">
        <div className="bg" />
        <div className="internal">
          <h4>FAQs</h4>
          <div className="items">
            {FAQS.map((item, i) => {
              return (
                <div
                  className={ClassNames({
                    item: true,
                    ["is-active"]: i === this.state.n
                  })}
                  key={i}
                  onClick={() => {
                    if (this.state.n !== i) {
                      this.setState({ n: i });
                    }
                  }}
                >
                  <h5 className="question">{item.question}</h5>
                  {this.state.n === i && (
                    <div
                      className="answer"
                      dangerouslySetInnerHTML={RenderHtml.go(item.answer)}
                    />
                  )}
                  <div className="action">
                    {this.state.n === i && (
                      <span
                        className="action"
                        onClick={e => {
                          this.setState({
                            n: null
                          });
                        }}
                      >
                        -
                      </span>
                    )}
                    {this.state.n !== i && <span className="action">+</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FAQs;



// WEBPACK FOOTER //
// ./src/home/faqs.js